<template>
  <div v-if="media.length">
    <div class="upload" v-for="(media, index) in media" :key="index">
      <figure>



        <img v-if="isImage(media)" :src="media.url" />
        <div v-else class="attachment">
          <doe-icon icon="attachment" class="mt-2" />
        </div>



      </figure>
      <div class="copy">
        <p>
          <span class="icon">
            <doe-icon icon="circleCheck" size="small" />
          </span>
          <strong>Successful</strong>
         
          <button class="absolute top-0 right-0" :aria-label="`Remove file ${media.name}`" @click="
              $emit('mediaDelete', {
                uuid: media.uuid
              })
            ">
            <doe-icon icon="times" size="small" />
          </button>
          
        </p>
        <p>
          {{ media.name }}
          <span class="filesize">{{ getFilesize(media.size) }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import DoeIcon from "@/components/icon/Icon";

export default {
  name: "DoeGallery",
  props: {
    media: {
      type: Array,
      required: true
    }
  },
  components: {
    DoeIcon
  },
  methods: {
    getFilesize(bytes) {
      let mb = (bytes / 1024 / 1024).toFixed(2);
      return `${mb} mb`;
    },
    isImage(media) {
      return ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'].includes(media.type);
    }
  }
};
</script>

<style lang="scss" scoped>
.upload {
  border-bottom: solid 1px #e6e6e6;
  height: 92px;
  margin-top: 20px;
  position: relative;
  width: 100%;
  max-width: 400px;
}
figure {
  border-radius: 4px;
  height: 72px;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  width: 93px;
}
img {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.attachment {
  background-color: #f2f2f2;
  color: #041e42;
  font-size: 50px;
  height: 72px;
  text-align: center;
}
.copy {
  padding: 5px 0 0 20px;
  position: absolute;
  top: 0;
  left: 93px;
  right: 0;
}
p strong {
  font-size: 18px;
  margin-bottom: 10px;
}
p a {
  cursor: pointer;
  float: right;
}
p span.icon {
  color: #13ce66;
  margin-right: 10px;
}
p span.filesize {
  color: #053f51;
}
</style>
